<style scoped lang="less">
.flexy {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.flexcenter {
	display: flex;
	align-items: center;
	justify-content: center;
}

.cilcle {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	font-size: 1.8rem;
	font-weight: 600;
	color: #fff;
}

.colbtn {
	color: #0079fe;
	text-decoration: underline;
	cursor: pointer;
}

.trainplanleft {
	padding-bottom: 40px;
	background-color: #fff;
	box-shadow: 2px 3px 7px 2px #666;
	border-radius: 11px;

	.trainplanlefttop {
		height: 12rem;
		border-radius: 10px;
		color: #fff;
		background-color: #07c160;
		box-sizing: border-box;
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
	}

	.trainplanleftcenter {
		justify-content: flex-start;
		align-items: flex-start;
		margin: 10px 0;
		padding: 0 10px;
		.trainplanlist {
			margin: 2px 0;
			font-size: 1rem;
			color: #000;
		}
		.trainplanpress {
			width: 100%;
			margin-top: 1rem;
			.trainpresstitle {
				justify-content: space-between;
				width: 100%;
				margin: 5px 0;
				// p:first-child {
				// 	font-size: 1rem;
				// 	color: #000;
				// }
			}
		}

		.circle {
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background-color: #999;
			margin-right: 10px;
		}
	}

	.trainplanleftbottom {
		padding: 0 10px;
		height: 19rem;

		.trainlisttables {
			font-size: 1rem;
		}

		.traintabitems {
			height: 2rem;
			justify-content: flex-start;
			margin-bottom: 5px;
			border-bottom: 1px solid #ccc;
			color: #000;
			font-size: 1rem;
			font-weight: 600;
		}

		.traintabitem {
			color: #666;
			padding: 10px 0;
			border-bottom: 1px solid #ccc;
		}
	}
}
.fonttitle {
	font-size: 1.2rem;
	color: #000;
	margin: 10px 0;
	// font-weight: 600;
}

.trainplanleftbottomtwo {
	padding: 0 10px;
	margin: 10px 0;
	height: 21rem;
	overflow-y: scroll;

	.fonttitle {
		margin-bottom: 20px;
	}
	img {
		margin: 20px;
	}
}

.trainlisttables {
	font-size: 1rem;
}

.traintabitems {
	height: 2rem;
	justify-content: flex-start;
	margin-bottom: 5px;
	border-bottom: 1px solid #ccc;
	color: #000;
	font-size: 1rem;
	font-weight: 600;
}

.traintabitem {
	color: #666;
	padding: 10px 0;
	border-bottom: 1px solid #ccc;
}

.trainplanright {
	// background-color: #fff;
	width: 63%;
	// border: 1px solid rgb(204, 204, 204);
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;

	.trainexecution {
		height: 35rem;
		width: 100%;
		background-color: #fff;
		border-radius: 5px;
		padding: 0 10px 20px 10px;
		box-shadow: 2px 4px 7px 2px #666;
		border-radius: 10px;
	}

	.trainexetitle {
		display: flex;
		align-items: center;
		padding: 10px;
		font-size: 1rem;
	}

	.trainexecutionbtn {
		margin-top: 1rem;
		height: 36rem;
		width: 100%;
		background-color: #fff;
		box-shadow: 2px 4px 7px 2px #666;
		border-radius: 10px;
		padding: 0 10px;
		overflow-y: scroll;
	}

	.tableexecu {
		margin-bottom: 10px;
	}

	.tableexitem {
		justify-content: flex-start;
		margin: 12px;
		// border-top: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
		padding: 18px 0;
	}
}

/deep/ .el-progress-bar__innerText {
	color: #fff !important;
}

/deep/ .el-dialog__body {
	padding-top: 0;
}

.userDetailFather {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
}
</style>
<template>
	<div>
		<titles titlename="实训计划详情" titlecontent="这里可以查看计划详情" :mbx="paths"></titles>
		<div class="trainplanxq flexcenter" style="justify-content: space-between;">
			<div class="trainplanleft" style="width: 35%;border-radius: 5px;">
				<div class="trainplanlefttop">
					<div class="flexcenter" style="justify-content: flex-start;">
						<div class="trainsfont cilcle flexcenter" :style="randomRgb()">{{ nowplanobj.spnametx }}</div>
						<p class="wrap" style="font-size: 1.4rem;margin-left: 10px;font-weight: 600;">{{ nowplanobj.SP_planName }}</p>
					</div>
					<div class="wrap" style="text-indent:24px;font-size: 1rem;-webkit-line-clamp: 3;">{{ nowplanobj.SP_planContent }}</div>
				</div>
				<div class="trainplanleftcenter flexy">
					<div class="trainplanlist flexcenter">
						<div class="circle"></div>
						<p>
							计划编号：
							<span style="color: #999;">{{ nowplanobj.SP_planNumber ?? '' }}</span>
						</p>
					</div>
					<div class="trainplanlist flexcenter">
						<div class="circle"></div>
						<p>
							计划状态：
							<span :style="{ color: nowplanobj.EnableorNot == 1 ? '#0079fe' : '#ff0000' }">{{ nowplanobj.EnableorNot == 1 ? '已开启' : '已关闭' }}</span>
						</p>
					</div>
					<div class="trainplanlist flexcenter">
						<div class="circle"></div>
						<p>
							创建者：
							<span style="color: #999;">{{ nowplanobj.UI_UserName ?? '' }}</span>
						</p>
					</div>
					<div class="trainplanlist flexcenter">
						<div class="circle"></div>
						<p>
							创建时间：
							<span style="color: #999;">{{ nowplanobj.CreatedTime }}</span>
						</p>
					</div>
					<div class="trainplanlist flexcenter">
						<div class="circle"></div>
						<p>
							截止时间：
							<span style="color: #999;">{{ nowplanobj.SP_indateDate }}</span>
						</p>
					</div>
					<div class="trainplanpress">
						<div class="trainpresstitle flexcenter">
							<p class="fonttitle">实训计划进度</p>
							<p style="color: #999;font-size: 1rem;">当前进度 {{ nowplanobj.Schedule }}%</p>
						</div>
						<div style="height: 2rem;width: 100%;">
							<el-progress :text-inside="true" :stroke-width="26" :percentage="nowplanobj.Schedule" status="success"></el-progress>
						</div>
					</div>
				</div>

				<div class="trainplanleftbottom">
					<p class="fonttitle">实训计划内容</p>
					<div class="trainlisttables">
						<div class="flexcenter traintabitems">
							<p style="width: 10%;">序号</p>
							<p style="width: 70%;">名称</p>
							<p style="width: 20%;">总进度</p>
						</div>
						<div class="flexcenter traintabitem" v-for="(item, index) in plancontentlist" :key="item.PC_GUID">
							<p style="width: 10%;margin-left: 5px;">{{ index + 1 }}</p>
							<p style="width: 70%;">{{ item.PC_planContent }}</p>
							<p style="width: 20%;">{{ item.Schedule }}%</p>
						</div>
					</div>
					<div class="flexcenter" style="justify-content: flex-end;margin: 22px 16px 22px 0;">
						<el-pagination
							background
							:page-size="4"
							@current-change="sizechanges"
							:current-page="pageindexs"
							layout="prev, pager, next"
							:total="pageallsicze"
						></el-pagination>
					</div>
				</div>

				<div class="trainplanleftbottomtwo">
					<p class="fonttitle">实训计划成员</p>
					<div class="userclist flexcenter" style="justify-content: flex-start;flex-wrap: wrap;">
						<div class="flexy" v-for="(item, index) in nowplanobj.sx_Learnorstudents" :key="item.UI_GUID">
							<img v-if="item.user" style="width: 60px;height: 60px;border-radius: 50%;" :src="item.user.ui_photoPath ? item.user.ui_photoPath : headers" alt="" />
							<p v-if="item.user" style="font-size: 1rem;">{{ item.user ? item.user.ui_userName : '' }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="trainplanright" style="width: 63%;">
				<div class="trainexecution">
					<p class="trainexetitle">
						<span style="display: block;width: 6px;height: 20px;background-color: #58A3F7;margin-right: 10px;"></span>
						<span>实训计划执行情况</span>
					</p>
					<div class="tableexecu">
						<el-table :data="tableData" style="width: 100%">
							<el-table-column prop="SP_planName" label="计划名称" width="280"></el-table-column>
							<el-table-column prop="UI_USERNAME" label="学员姓名" width="120"></el-table-column>
							<el-table-column label="进度状态">
								<template slot-scope="scope">
									<el-progress :text-inside="true" :stroke-width="24" :percentage="scope.row.Schedule"></el-progress>
								</template>
							</el-table-column>
							<el-table-column prop="address" label="详情" width="120">
								<template slot-scope="scope">
									<!-- <el-button type="text" @click="dialogTableVisible = true; getUserSingleDetails(scope.row.UI_GUID)" >查看</el-button> -->
									<el-button
										type="text"
										@click="
											dialogTableVisible = true;
											getUserSingleDetails(scope.row);
										"
									>
										查看
									</el-button>
									<!-- 对话框 -->

									<el-dialog title="实训计划内容" :visible.sync="dialogTableVisible">
										<!-- <div class="userDetailFather">
											<div class="userDetail">姓名: {{ userDatar.UI_USERNAME }}</div>
									
										</div> -->

										<div class="trainlisttables">
											<div class="flexcenter traintabitems">
												<p style="width: 10%;">序号</p>
												<p style="width: 30%;">名称</p>
												<p style="width: 20%;">完成时间</p>
												<p style="width: 20%;">成绩</p>
												<p style="width: 20%;">进度</p>
											</div>
											<div class="flexcenter traintabitem" v-for="(item, index) in userDetailData.UserPlanlog" :key="item.PC_GUID">
												<p style="width: 10%;margin-left: 5px;">{{ index + 1 }}</p>
												<p style="width: 30%;">{{ item.PC_planContent }}</p>
												<p style="width: 20%;" :style="{ color: item.LOL_recordTime ? '' : 'red' }">{{ item.LOL_recordTime ?? '未开始或已延期' }}</p>
												<p style="width: 20%;" :style="{ color: item.LOL_recordTime ? '' : 'red' }">{{ item.LOL_trainScore ?? '未开始或已延期' }}</p>
												<p style="width: 20%;">{{ item.LOL_schedule }}%</p>
											</div>
										</div>
									</el-dialog>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<div class="flexcenter" style="justify-content: flex-end;margin-right: 1rem;">
						<el-pagination
							background
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="planuserobj.pageIndex"
							:page-size="planuserobj.pageSize"
							layout="prev, pager, next"
							:total="tablesall"
						></el-pagination>
					</div>
				</div>

				<div class="trainexecutionbtn ">
					<p class="trainexetitle">
						<span style="display: block;width: 6px;height: 20px;background-color: #58A3F7;margin-right: 10px;"></span>
						<span>实训动态</span>
					</p>
					<div class="tableexecu" v-if="trainlistpower.length > 0">
						<div class="tableexitem flexcenter" v-for="(item, index) in trainlistpower" :key="item.td_id">
							<img
								:src="item.user ? (item.ui_photoPath ? item.ui_photoPath : item.user.ui_photoPath) : headers"
								style="width: 50px;height: 50px;border-radius: 50%;"
								alt=""
							/>
							<div class="flexy" style="align-items: baseline;">
								<p style="margin-bottom: 10px;margin-left: 10px;color: #ccc;font-size: 1rem;">
									{{ item.user ? item.user.ui_realName : '' }}进行了
									<span style="color:#0079fe ;">{{ item.td_content }}</span>
									计划任务。
								</p>
								<p style="font-size: 1rem;color: #ccc;">{{ item.td_time }}</p>
							</div>
						</div>
					</div>

					<el-empty v-if="trainlistpower.length == 0" description="暂无动态请提醒学生尽快完成实训"></el-empty>

					<div v-if="trainpower.trainspoweall > 10" class="flexcenter" style="margin: 12px 0;" @click="looksmores">
						<button style="border: 1px solid #ccc;border-radius: 20px;padding: 10px 50px;color: #ccc;">查看更多</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getplanfrist, getuserplanlist, getSingleUserDetails, cetGetPagetrends } from '@/request/api/pingtai/trainsplan';

import { splitArray } from '@/utils/utils';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			//对话框
			userDetailData: [],
			dialogTableVisible: false,
			dialogFormVisible: false,

			// 标题
			paths: [
				{
					path: '/allmanage/trainspressmange',
					name: '实训计划管理'
				},
				{
					path: '/allmanage/trainspressmangexq',
					name: '实训计划详情'
				}
			],
			// 实训计划列表
			traiinplanlist: [],
			// 实训执行情况
			tableData: [],
			currentPage: 1, //初始页
			pagesize: 5, //每页展示的数据
			//单个用户计划详情数据
			userDetailData: [],

			// 当前计划id
			spguid: '',
			uiguid: '',
			userDatar: '',
			nowplanobj: {},
			plancontentlist: [],
			plancontentlists: [],
			pageindexs: 1,
			pageallsicze: 4,
			headers: require('@/images/header.png'),
			planuserobj: {
				pageIndex: 1,
				pageSize: 6,
				SP_GUID: ''
			},
			tablesall: 0,
			trainpower: {
				pageIndex: 1,
				pageSize: 6,
				SP_GUID: '',
				trainspoweall: 0
			},
			trainlistpower: []
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.spguid = this.$route.query.spguid;
		this.planuserobj.SP_GUID = this.spguid;
		this.getplanfirstr();
		this.getplanuserlist();
		this.gettrainsdt();
	},
	methods: {
		looksmores() {
			this.trainpower.pageSize += 10;
			this.gettrainsdt();
		},
		// 实训动态
		gettrainsdt() {
			cetGetPagetrends(this.trainpower).then(res => {
				if (res.data.code == 1) {
					this.trainlistpower = res.data.data.list;
					this.trainpower.trainspoweall = res.data.data.totalCount;
					this.trainlistpower.forEach(item => {
						item.td_id = 'a' + item.td_id;
						item.ui_photoPath = item.user ? item.user.ui_photoPath : this.headers;
					});
				}
			});
		},
		//===============分页==================
		handleSizeChange(size) {
			this.pagesize = size;
		},
		handleCurrentChange(currentPage) {
			this.planuserobj.pageIndex = currentPage;
			this.getplanuserlist();
		},
		//=================END===================

		//=============随机改变背景颜色===============
		randomRgb(item) {
			let R = Math.floor(Math.random() * 130 + 110);
			let G = Math.floor(Math.random() * 130 + 110);
			let B = Math.floor(Math.random() * 130 + 110);
			//console.log(R,G,B)
			return {
				background: 'rgb(' + R + ',' + G + ',' + B + ', .5)'
			};
		},
		//================END=================

		getplanfirstr() {
			let dateasf = {
				spguid: this.spguid
			};
			getplanfrist(dateasf).then(res => {
				this.nowplanobj = res.data.data;
				this.nowplanobj.spnametx = this.nowplanobj.SP_planName.slice(0, 1);
				//console.log('spnametx==============>', this.nowplanobj.spnametx)
				if (this.nowplanobj.plancontentlist.length > 4) {
					// this.nowplanobj.plancontentlist
					this.plancontentlists = splitArray(this.nowplanobj.plancontentlist, 4);
					// console.log('plancontentlist===========>', this.plancontentlists);
					this.plancontentlist = this.plancontentlists[this.pageindexs - 1];
				} else {
					this.plancontentlist = this.nowplanobj.plancontentlist;
				}
				// console.log('plancontentlist===========>', this.plancontentlist);
				this.pageallsicze = this.nowplanobj.plancontentlist.length;
				// console.log('pageallsicze===========>', this.plancontentlists)
			});
		},
		//改变计划内容
		sizechanges(e) {
			// console.log(e)
			this.plancontentlist = this.plancontentlists[e - 1];
			// console.log(this.plancontentlist);
		},
		// 获取计划执行情况
		getplanuserlist() {
			getuserplanlist(this.planuserobj).then(res => {
				this.tableData = res.data.data.list;
				this.tablesall = res.data.data.totalCount;

				//console.log("this.tableData========>", this.tableData);
				//console.log("this.tablesall==========>", this.tablesall);
			});
		},

		//查询单个用户计划详情
		getUserSingleDetails(userData) {
			this.uiguid = userData.UI_GUID;
			let oneUserData = {
				SP_GUID: this.spguid,
				UI_GUID: this.uiguid,
				userDatar: userData
			};

			getSingleUserDetails(oneUserData).then(res => {
				this.userDetailData = res.data.data;
				this.userDetailData.userDatar = oneUserData.userDatar;
				this.userDatar = userData;
				console.log('userDetailData================>', this.userDetailData);
			});
		}
	},
	components: {
		titles
	}
};
</script>
